import { System, SystemImpl } from 'minecs';
import type { GameModel } from 'yage/game/GameModel';
import { AirportState } from '../components/index.js';
import { state } from '../services/world.js';
import { placeLayout } from '../services/world.js';
import { tier } from '../domain/airports.js';
import { applyLayout, activeLayout } from '../domain/active-layout.js';
import { gatePlanKey } from '../domain/layout.js';

/** Make the airport being played the active floor plan, moving placed pieces if its plan differs. */
export function syncLayout(g: GameModel) {
    const code = tier(state(g)).code, before = activeLayout();
    if (before === code) return;
    applyLayout(code);
    // Airports on the same floor plan need nothing moved.
    if (!before || gatePlanKey(before) !== gatePlanKey(code)) placeLayout(g);
}
/** Keep the active floor plan on the airport being played, even if the airport changes under the world. */
@System(AirportState)
export class AirportLayoutSync extends SystemImpl<GameModel> {
    static depth = 50;
    run = (g: GameModel) => syncLayout(g);
}
